import { render, staticRenderFns } from "./EditReservation.vue?vue&type=template&id=82c67bea"
import script from "./EditReservation.vue?vue&type=script&lang=ts"
export * from "./EditReservation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports